import styled, { keyframes, css } from 'styled-components';

/* ── paleta base (design system de conceitos/calendário/turma) ── */
const TEAL = 'var(--teal)';
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';
//const GREEN = 'var(--green)';
//const GREEN_SOFT = 'var(--green-soft)';
const RED = 'var(--red)';
const RED_SOFT = 'var(--red-soft)';
//const AMBER = 'var(--amber, #d97706)';

//const CORAL = 'var(--coral)';
const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '380px' };

const expand = keyframes`
  from { opacity: 0; transform: translateY(-6px); max-height: 0; }
  to   { opacity: 1; transform: translateY(0);    max-height: 9999px; }
`;
const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(29, 139, 90, 0.45); }
  50%      { box-shadow: 0 0 0 5px rgba(29, 139, 90, 0); }
`;

/* ── Layout base ── */
export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  padding: 16px;
  display: flex;
  justify-content: center;
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; }
`;

export const ContainerDivs = styled.div`
  width: 100%;
  max-width: 960px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;
  @media (max-width: ${bp.mobile}) { gap: 10px; }
`;

/* ── Botão base ── */
const ActionBase = styled.button`
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  border-radius: 10px;
  padding: 10px 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  transition: transform 0.12s ease, filter 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
  &:hover { filter: brightness(1.05); transform: translateY(-1px); }
  &:active { transform: translateY(0); }
  &:disabled { opacity: 0.55; cursor: not-allowed; transform: none; filter: none; }
  @media (max-width: ${bp.mobile}) { font-size: 12px; padding: 10px 16px; }
`;

/* ── HERO: cartão de perfil do funcionário ── */
export const Emp = styled.div`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 26px 28px;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_LIGHT} 100%);
  color: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 24px ${TEAL_GLOW};
  animation: ${fadeUp} 0.4s ease;
  &::before, &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }
  &::before { width: 200px; height: 200px; top: -90px; right: -50px; }
  &::after  { width: 140px; height: 140px; bottom: -80px; right: 120px; }
  @media (max-width: ${bp.mobile}) { padding: 20px 18px; border-radius: 16px; }
`;

export const EmployeeInfo = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Pro = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  @media (max-width: ${bp.mobile}) { gap: 14px; }
`;

export const ProfilePhoto = styled.div`
  width: 76px;
  height: 76px;
  min-width: 76px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  border: 2px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 26px;
  color: #fff;
  text-transform: uppercase;
  backdrop-filter: blur(4px);
  @media (max-width: ${bp.mobile}) { width: 60px; height: 60px; min-width: 60px; font-size: 21px; }
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

/* nome em destaque + cargo */
export const EmpName = styled.h1`
  margin: 0;
  font-size: 23px;
  font-weight: 800;
  letter-spacing: 0.2px;
  word-break: break-word;
  @media (max-width: ${bp.mobile}) { font-size: 19px; }
  @media (max-width: ${bp.small}) { font-size: 17px; }
`;

export const RoleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RolePill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 999px;
  padding: 4px 12px;
  backdrop-filter: blur(4px);
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-radius: 999px;
  padding: 4px 12px;
  ${({ $active }) => $active
    ? css`background: rgba(46, 204, 113, 0.22); color: #c8f7da; &::before { content: '●'; font-size: 8px; animation: ${pulse} 2.2s infinite; border-radius: 50%; }`
    : css`background: rgba(231, 76, 60, 0.25); color: #ffd2cc; &::before { content: '●'; font-size: 8px; }`}
`;

/* grade de detalhes (contato/documentos) dentro do hero */
export const DetailGrid = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 11px;
  padding: 9px 13px;
  backdrop-filter: blur(4px);
  min-width: 0;
  .k { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; opacity: 0.72; }
  .v { font-size: 13.5px; font-weight: 600; word-break: break-word; }
`;

export const DivButtomEdit = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const Btt02 = styled(ActionBase)`
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  backdrop-filter: blur(4px);
`;

/* ── Rótulo de seção ── */
export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 2px 0;
  color: ${GRAY_TEXT};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  &::after { content: ''; flex: 1; height: 1px; background: ${GRAY_LINE}; }
`;

/* ── Cartões brancos (turmas, diário) ── */
export const DivInfo = styled.div`
  width: 100%;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: ${fadeUp} 0.35s ease backwards;
  transition: box-shadow 0.18s ease;
  &:hover { box-shadow: 0 5px 16px rgba(0, 0, 0, 0.05); }
  @media (max-width: ${bp.mobile}) { padding: 14px; border-radius: 12px; }
`;

export const TitleInfo = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: ${TEAL_TEXT};
  display: flex;
  align-items: center;
  gap: 8px;
  .em { font-size: 17px; }
  @media (max-width: ${bp.mobile}) { font-size: 14px; }
`;

export const Span = styled.span`
  display: block;
  font-size: 14px;
  color: var(--text-2);
`;

/* grade de turmas em chips */
export const Matter = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  span {
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    padding: 11px 14px;
    border-radius: 10px;
    font-size: 13.5px;
    font-weight: 600;
    border: 1px solid var(--teal-soft);
  }
`;

/* aviso quando não há turmas */
export const EmptyHint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 16px;
  border: 1px dashed ${GRAY_LINE};
  border-radius: 11px;
  color: ${GRAY_TEXT};
  font-size: 13.5px;
  line-height: 1.5;
  background: ${GRAY_BG};
  .em { font-size: 20px; flex-shrink: 0; }
`;

export const DivAddEmp = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
`;

export const AddEmp = styled.div`
  display: flex;
  justify-content: center;
`;

export const DivShowMatter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/* ── Bloco "Diário" (seletor de bimestre) ── */
export const Input = styled.div`
  width: 100%;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: ${fadeUp} 0.35s ease backwards;
  h2 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: ${TEAL_TEXT};
    display: flex;
    align-items: center;
    gap: 8px;
    &::before { content: '📔'; }
  }
  @media (max-width: ${bp.mobile}) { padding: 14px; border-radius: 12px; }
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 13px;
  color: ${GRAY_TEXT};
`;

export const Select = styled.select`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid ${GRAY_LINE};
  border-radius: 11px;
  font-size: 14px;
  font-family: inherit;
  color: var(--text-2);
  background: ${GRAY_BG};
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:focus { outline: none; border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.12); }
`;

export const ErrorMessage = styled.div`
  color: ${RED};
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  &::before { content: '⚠️'; }
`;

/* ── Botões de ação ── */
export const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  & > div { display: flex; gap: 10px; flex-wrap: wrap; justify-content: center; }
  @media (max-width: ${bp.mobile}) {
    flex-direction: column;
    & > div { flex-direction: column; width: 100%; }
    & > div > button { width: 100%; }
  }
`;

export const Button = styled(ActionBase)`
  background: ${TEAL};
  color: #fff;
  box-shadow: 0 2px 8px ${TEAL_GLOW};
  padding: 12px 22px;
`;

export const ButtonRemove = styled(ActionBase)`
  background: ${RED};
  color: #fff;
  padding: 12px 22px;
`;

export const Btt01 = styled(ActionBase)`
  background: ${RED};
  color: #fff;
  padding: 12px 22px;
`;

export const ButtonCancel = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

/* ── Aviso de remoção (inline) ── */
export const AddMatterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  background: var(--surface);
  border: 1px solid #f1cdcd;
  border-left: 4px solid ${RED};
  border-radius: 14px;
  padding: 20px;
  animation: ${fadeUp} 0.3s ease;
`;

export const WarningBox = styled.div`
  width: 100%;
  padding: 14px 18px;
  background: ${RED_SOFT};
  border-radius: 10px;
  font-size: 14.5px;
  text-align: center;
  color: ${RED};
  font-weight: 600;
`;

/* ── Skeleton ── */
const skeletonBase = css`
  background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.3s linear infinite;
  border-radius: 8px;
`;
export const SkeletonLine = styled.div`
  ${skeletonBase}
  height: ${({ $h }) => $h || '14px'};
  width: ${({ $w }) => $w || '100%'};
  margin: 4px 0;
`;
export const SkeletonCard = styled.div`
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const SkeletonHero = styled.div`
  ${skeletonBase}
  height: 220px;
  border-radius: 18px;
  background: linear-gradient(90deg, #dde7ea 0%, #e9f0f2 50%, #dde7ea 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.3s linear infinite;
`;
export const LoadingSpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

/* ── Modal (seleção de turma) ── */
export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 30, 38, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  animation: ${fadeIn} 0.15s ease;
  overscroll-behavior: contain;
  @media (max-width: ${bp.mobile}) { padding: 0; align-items: flex-end; }
`;

export const Modal = styled.div`
  background: var(--surface);
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
  animation: ${expand} 0.2s ease;
  max-height: 88vh;
  overflow-y: auto;
  h2 {
    margin: 0 0 16px;
    font-size: 17px;
    font-weight: 700;
    color: ${TEAL_TEXT};
    text-align: center;
  }
  @media (max-width: ${bp.mobile}) { border-radius: 18px 18px 0 0; padding: 22px 18px; max-width: 100%; }
`;

export const ClassList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClassItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 13px 15px;
  border-radius: 11px;
  background: ${GRAY_BG};
  border: 1px solid ${GRAY_LINE};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
  &:hover { background: ${TEAL_SOFT}; border-color: #cfe3e9; transform: translateX(2px); }
  span { font-size: 13.5px; color: var(--text-2); font-weight: 600; }
`;